/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({ questionnaire, setIncludeDeclaration }) {
  return questionnaire.map((question) => {
    if (question.idQuestion === 1954) {
      const includeDeclarationQst = questionnaire.find((qst) => qst.idQuestion === 1946);

      const showAttachmentQst = includeDeclarationQst?.idAnswerOption === 7599;

      question.visibleQuestion = showAttachmentQst ? 1 : 0;

      if (question.answer !== '' && JSON.parse(question.answer).length > 0) {
        question.hiddenInput = true;
      }

      setIncludeDeclaration(!showAttachmentQst);
    }

    return question;
  })
}

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  setIncludeDeclaration,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete
}) {
  try {
    let saveQuestionnaire = false;

    const newQuestionnaireAnswersToDelete = []
    const newDocumentsToDelete = []

    if (question.idQuestion === 1946) {
      saveQuestionnaire = true;

      const showAttachmentQst = value.idAnswerOption === 7599;

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if ([1954].includes(qst.idQuestion)) {
          qst.visibleQuestion = value?.idAnswerOption !== 7600;
          qst.hiddenInput = false;

          if (!qst.visibleQuestion) {
            if (qst.idQuestionnaireAnswers) {
              newQuestionnaireAnswersToDelete.push(qst.idQuestionnaireAnswers);
            }

            const attachment = qst?.answer?.length ? qst?.answer[0] : null;
            if (attachment) {
              newDocumentsToDelete.push(attachment.documentId)
            }

            qst.answer = null;
            qst.idAnswerOption = null;
            qst.answerJson = null;
            setFieldValue(qst.key, []);
          }
        }

        return qst;
      })

      setIncludeDeclaration(!showAttachmentQst)
    }

    if (question.idQuestion === 1954) {
      saveQuestionnaire = true;

      if (!Array.isArray(value)) {
        const attachment = question?.answer?.length ? question?.answer[0] : null;
        if (attachment) {
          newDocumentsToDelete.push(attachment.documentId)
        }
      } else {
        if (question.idQuestionnaireAnswers) {
          setQuestionnaireAnswersToDelete([
            ...questionnaireAnswersToDelete
              .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers !== question.idQuestionnaireAnswers),
          ])
        }
      }

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if (qst.idQuestion === question.idQuestion) {
          if (value.length) {
            qst.hiddenInput = true
          } else {
            qst.hiddenInput = false
          }
        }
        return qst
      })
    }

    if (newQuestionnaireAnswersToDelete.length) {
      setQuestionnaireAnswersToDelete([
        ...questionnaireAnswersToDelete,
        ...newQuestionnaireAnswersToDelete
          .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers)
          .filter((idQuestionnaireAnswers) => !questionnaireAnswersToDelete.includes(idQuestionnaireAnswers))
      ]);
    }

    if (newDocumentsToDelete.length) {
      setDocumentsToDelete([
        ...documentsToDelete,
        ...newDocumentsToDelete
          .filter((documentId) => !documentsToDelete.includes(documentId))
      ]);
    }

    if (saveQuestionnaire) setQuestionnaire(questionnaireUpdated)
  } catch (e) {
    console.log('DECLARATION - handleQuestionChange - error', e);
  }
}


const events = {
  handleInitialAdjustments,
  handleQuestionChange
};

export { events };